import React, { FC } from 'react';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import { IPageProps } from '@folx-types/flow-steps';

export interface IUnpaidMembershipPageContent {
	pageHeader: string;
	pageDescription: string;
	supportCta: string;
	supportCtaLink: string;
}

interface IUnpaidMembershipProps extends IPageProps {
	pageContent: IUnpaidMembershipPageContent;
}

const UnpaidMembership: FC<IUnpaidMembershipProps> = ({ pageContent }) => {
	const { pageHeader, pageDescription, supportCta, supportCtaLink } = pageContent;

	return (
		<FlexColumn gap="lg">
			<HeadingText>{pageHeader}</HeadingText>
			<BasicText>{pageDescription}</BasicText>
			<Button variant="secondary" label={supportCta} href={supportCtaLink} newTab />
		</FlexColumn>
	);
};

export default UnpaidMembership;
